module.exports = __webpack_public_path__ + "img/p12.75af1833.png";